import React from 'react'
import { GetParamsData } from '$Deposits/lib/LibCommonData'

export default class BankNone extends React.Component {


    render() {
        const { LivechatClick,onChange, methods = '' } = this.props
        const { webPiwikEvent } = GetParamsData();
        let text = methods === "PHC" || methods === "BQR" ? 
        <p>
            Hiện tại tất cả các loại thẻ cào đều không khả dụng, vui lòng chọn phương thức gửi tiền khác để tiếp tục 
            <span onClick={() => document.querySelector(".deposit-sprite.LB")?.click()}>gửi tiền</span> hoặc liên <br/> hệ 
            <span onClick={() => {
                LivechatClick();
                webPiwikEvent("Deposit", "Contact CS", `Deposit_${methods === "PHC" ? "Mobile_Load" : "BQR"}_S_CS`);
            }}>Live Chat</span> để được hỗ trợ.
        </p>
        : <p>
            Hiện tại tất cả ngân hàng của FUN88 đều không khả dụng, nếu bạn đã chuyển tiền mà chưa hoàn tất thông tin gửi tiền, vui lòng cung cấp thông tin gửi tiền 
            <span onClick={onChange}>tại đây</span> hoặc liên <br/> hệ <span onClick={() => {
                LivechatClick();
                webPiwikEvent("Deposit", "Contact CS", `Deposit_${methods}_C_CS`);
            }}>Live Chat</span> để được hỗ trợ
        </p>
        return (
            <div className='bankNone'>
                <span className={methods + '-bankNone'} />
                {text}
            </div>
        )
    }
}
